import BunkeyAPI from "../api/BunkeyAPI";
import {
  PERMISSION_SHOW,
  PERMISSION_HIDE,
  SET_ITEM,
  GET_ITEM,
  GET_ITEM_SUCCESS,
  GET_ITEM_FAILURE,
  MYPERMISSION_REQUETS,
  MYPERMISSION_REQUETS_SUCCESS,
  MYPERMISSION_REQUETS_FAILURE,
  GIVING_PERMISSION,
  SET_IS_FETCHING_OBJECT_GROUPS,
  UNSET_IS_FETCHING_OBJECT_GROUPS,
  PERMISSION_SHOW_MODAL,
  PERMISSION_HIDE_MODAL,
  UNSET_IS_FETCHING_OBJECT_GROUPS_MODAL,
  SET_IS_FETCHING_OBJECT_GROUPS_MODAL
} from "../constants/permission-types";
import { NOTIFICATION_GET_DATA_SUCCESS } from "../constants/notification-types";
import store from "../store";
import { ASSET_EXPLORE_UPDATE_FROM_PERMISSION } from "../constants/assets-explore-types";
import { ASSET_ROOT_UPDATE_FROM_PERMISSION } from "../constants/assets-root-types";
import { ASSET_SHARED_UPDATE_FROM_PERMISSION } from "../constants/assets-share-types";
import { ASSET_FAVORITES_UPDATE_FROM_PERMISSION } from "../constants/assets-favorites-types";
import { ASSET_LAST_UPLOAD_UPDATE_FROM_PERMISSION } from "../constants/assets-lastupload-types";
import { ASSET_CONFIRM_UPDATE_FROM_PERMISSION } from "../constants/assets-confirm-types";
import { sendNotification } from "../utils";
// import socket from '../utils/sockets'
import Socket from "../utils/sockets";
//
export const showPermission = item => {
  return (dispatch, getState) => {
    const {
      client: { workclient }
    } = getState();
    dispatch(setIsfetchingObjectGroups());
    BunkeyAPI({
      url: `clients/${workclient}/objects/${item._id}/get-object-groups`,
      method: "GET"
    })
      .then(res => {
        dispatch({
          type: PERMISSION_SHOW,
          payload: {
            show: true,
            item: res.data[0]
          }
        });
        dispatch(unsetIsfetchingObjectGroups());
      })
      .catch(err => {
        dispatch(hidePermission());
        dispatch(unsetIsfetchingObjectGroups());
      });
  };
};
export const showPermissionModal = item => {
  return (dispatch, getState) => {
    const {
      client: { workclient }
    } = getState();
    dispatch(setIsfetchingObjectGroupsModal());
    BunkeyAPI({
      url: `clients/${workclient}/objects/${item._id}/get-object-groups`,
      method: "GET"
    })
      .then(res => {
        dispatch({
          type: PERMISSION_SHOW_MODAL,
          payload: {
            showModal: true,
            item: res.data[0]
          }
        });
        dispatch(unsetIsfetchingObjectGroupsModal());
      })
      .catch(err => {
        dispatch(hidePermission());
        dispatch(unsetIsfetchingObjectGroupsModal());
      });
  };
};
export const setIsfetchingObjectGroups = () => dispatch =>
  dispatch({ type: SET_IS_FETCHING_OBJECT_GROUPS });
export const unsetIsfetchingObjectGroups = () => dispatch =>
  dispatch({ type: UNSET_IS_FETCHING_OBJECT_GROUPS });

export const setIsfetchingObjectGroupsModal = () => dispatch =>
  dispatch({ type: SET_IS_FETCHING_OBJECT_GROUPS_MODAL });
export const unsetIsfetchingObjectGroupsModal = () => dispatch =>
  dispatch({ type: UNSET_IS_FETCHING_OBJECT_GROUPS_MODAL });

export const hidePermission = () => {
  return dispatch => {
    dispatch({ type: PERMISSION_HIDE });
  };
};
export const hidePermissionModal = () => {
  return dispatch => {
    dispatch({ type: PERMISSION_HIDE_MODAL });
  };
};
export const getItem = id => {
  return (dispatch, getState) => {
    dispatch({ type: GET_ITEM });
    const defaultPermissions = getState().group.defaultPermissions.slice();
    BunkeyAPI({
      url: `/clients/object/${id}`,
      method: "GET"
    })
      .then(resp => {
        const newItem = {
          _id: resp.data._id,
          type: resp.data.type,
          name: resp.data.name,
          lowQualityURL: resp.data.lowQualityURL,
          mediaQualityURL: resp.data.mediaQualityURL,
          originalURL: resp.data.originalURL,
          metadata: resp.data.metadata,
          parents: resp.data.parents,
          createdAt: resp.data.createdAt,
          group: resp.data.group,
          objectGroups: resp.data.objectGroup,
          matrix: defaultPermissions.map(def => {
            const exists = resp.data.group.find(r =>
              r.permissions.find(
                item => item.action === def.action && item.enabled === true
              )
            );
            return {
              action: def.action,
              enabled: exists ? true : false
            };
          })
        };

        const keyCollection = store.getState().app.keyCollection;

        dispatch({
          type: GET_ITEM_SUCCESS,
          payload: newItem
        });

        switch (keyCollection) {
          case "assetsExplore":
            dispatch({
              type: ASSET_EXPLORE_UPDATE_FROM_PERMISSION,
              payload: newItem
            });
            break;
          case "assetsRoot":
            dispatch({
              type: ASSET_ROOT_UPDATE_FROM_PERMISSION,
              payload: newItem
            });
            break;
          case "assetsShared":
            dispatch({
              type: ASSET_SHARED_UPDATE_FROM_PERMISSION,
              payload: newItem
            });
            break;
          case "assetsFavorites":
            dispatch({
              type: ASSET_FAVORITES_UPDATE_FROM_PERMISSION,
              payload: newItem
            });
            break;
          case "assetsLastUploads":
            dispatch({
              type: ASSET_LAST_UPLOAD_UPDATE_FROM_PERMISSION,
              payload: newItem
            });
            break;
          case "assetsConfirm":
            dispatch({
              type: ASSET_CONFIRM_UPDATE_FROM_PERMISSION,
              payload: newItem
            });
            break;

          default:
            break;
        }
      })
      .catch(err => {
        dispatch({ type: GET_ITEM_FAILURE });
      });
  };
};

export const setItem = item => {
  return dispatch => {
    dispatch({
      type: SET_ITEM,
      payload: item
    });
  };
};

export const sendPermissionRequest = (
  creatorEmail,
  creatorId,
  creatorName,
  permissions,
  groupName,
  groupId,
  requestingUserId,
  requestingUserName,
  requestingUserEmail,
  clientId,
  intl
) => {
  return dispatch => {
    dispatch({ type: MYPERMISSION_REQUETS });
    BunkeyAPI({
      url: `/groups/requestPermissions/`,
      method: "POST",
      data: {
        creatorEmail,
        creatorId,
        creatorName,
        permissions,
        groupName,
        groupId,
        requestingUserId,
        requestingUserName,
        requestingUserEmail,
        clientId
      }
    })
      .then(resp => {
        dispatch({
          type: MYPERMISSION_REQUETS_SUCCESS
        });
        const { client, authUser } = store.getState();
        const msgSocketData = {
          data: resp.data,
          channel: client.workclient,
          requestUser: authUser.user,
          creatorUser: creatorId
        };
        Socket.getInstance().emit("request_client_permissions", msgSocketData);
      })
      .catch(err => {
        dispatch({
          type: MYPERMISSION_REQUETS_FAILURE,
          payload: err
        });
        sendNotification("error", intl);
      });
  };
};

// función que guarda estado que permite abrir modal de solicitud de permisos a usuario admin
export const givingPermissions = value => {
  return dispatch => {
    dispatch({
      type: GIVING_PERMISSION,
      payload: value
    });
  };
};
/**
 *
 * @param {*} client
 * @param {*} creatorUser
 * @param {*} intl
 * @name getOnlyPermissions
 * @author Victor Smith
 */
export const getOnlyPermissions = (client, creatorUser, intl) => {
  return dispatch => {
    BunkeyAPI({
      url: `/groups/requestPermissions/${client}/getOnlyPermissions/${creatorUser}`,
      method: "GET"
    })
      .then(resp => {
        dispatch(showModalOnSocket(resp.data));
      })
      .catch(err => {
        sendNotification(
          "error",
          intl,
          intl.formatMessage({ id: "error_getting_permissions" })
        );
      });
  };
};
/**
 *
 * @param {*} userRequests
 * @name showModalOnSocket
 * @author Victor Smith
 */
export const showModalOnSocket = userRequests => {
  const _showModal = store.getState().notifications.showModal;
  return dispatch => {
    dispatch({
      type: NOTIFICATION_GET_DATA_SUCCESS,
      payload: {
        userRequests: userRequests,
        showNotification: _showModal ? false : userRequests.length > 0,
        showModal: userRequests.length > 0
      }
    });
  };
};
